'use client';

import type { Country } from '@eliadmin/core/src/api/general/types/general-types';
import {
  AddressFields,
  DELIVERY_FIELDS,
} from '@eliadmin/core/src/components/dlz/auth/register/address-fields';
import { REGISTER_COPY } from '@eliadmin/core/src/components/dlz/auth/register/register-copy';
import { RegisterCard } from '@eliadmin/core/src/components/dlz/auth/register/register-card';
import { TextField } from '@eliadmin/core/src/components/dlz/auth/register/register-fields';

/**
 * Figma „Doručovacia adresa“ (60260:30265): the delivery address of a company with the recipient
 * row. A private person has no design for it (the checkbox is only drawn), so the same card without
 * the recipient row is shown – see the report.
 */
export function DeliveryCard({
  countries,
  withRecipient,
}: {
  countries: Country[];
  withRecipient: boolean;
}) {
  return (
    <RegisterCard title={REGISTER_COPY.delivery.title} spacing="compact">
      <div className="flex flex-col gap-4">
        {withRecipient ? (
          <div className="grid gap-4 md:grid-cols-2">
            <TextField
              name="delivery_company"
              label={REGISTER_COPY.delivery.recipient}
              required
              autoComplete="shipping organization"
              placeholder={REGISTER_COPY.delivery.recipient}
            />
            <TextField
              name="delivery_contact"
              label={REGISTER_COPY.delivery.contact}
              autoComplete="shipping name"
              placeholder={REGISTER_COPY.delivery.contactPlaceholder}
            />
          </div>
        ) : null}
        <AddressFields
          fields={DELIVERY_FIELDS}
          countries={countries}
          required
          autoCompletePrefix="shipping "
        />
      </div>
    </RegisterCard>
  );
}
